@keyframes pulse-old {
  0% {
    transform: scaleY(1);
    transform-origin: 50% 50%;
  }

  50% {
    transform: scaleY(0.7);
    transform-origin: 50% 50%;
  }

  100% {
    transform: scaleY(1);
    transform-origin: 50% 50%;
  }
}

.root {
  :global {
    .bar {
      transform-origin: 50% 50%;
      animation: pulse-old 750ms infinite;
      animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.335);
    }

    .bar-1 {
      animation-delay: 1200ms;
    }

    .bar-3 {
      animation-delay: 225ms;
    }

    .bar-2 {
      animation-delay: 375ms;
    }

    .bar-4 {
      animation-delay: 490ms;
    }

    .bar-5 {
      animation-delay: 640ms;
    }
  }
}
